import { types } from 'mobx-state-tree';
import { Sentiment, Sentiments } from 'globals/types';

export interface ReasonCodeProps {
  code: string;
  sentiment: Sentiment;
  translation: string;
}

export const ReasonCode = types.model({
  code: types.string,
  translation: types.string,
  sentiment: types.enumeration(Sentiments),
});
